import { maybeFetchCurrentTrackingToken } from 'core_main/api/tracking';
import { get, post } from 'core_main/request';
import { createAttachments } from '../attachments';
import {
  validateMessageParams,
  makeGetChatMessageAttachmentsEndpoint,
  makePostChatMessageEndpoint,
  makePostChatAssistantMessageEndpoint,
  makeGetHistoricalMessagesEndpoint,
} from './helpers';
import {
  ChatMessagesData,
  FetchHistoricalMessagesOptions,
  GetChatMessageAttachmentsApiResponse,
} from './types';

export const createMessage = (sessionId: string, options) => {
  const validateMessageParamsError = validateMessageParams(sessionId, options);

  if (validateMessageParamsError) {
    return Promise.reject(validateMessageParamsError);
  }

  const body = options?.body;
  const payload = options?.payload;
  const attachments = options?.attachments;
  const lastDeflection = options?.lastDeflection;
  const isInAssistantMode = options?.isInAssistantMode;
  const initAssistantPayload = options?.initAssistantPayload;

  return maybeFetchCurrentTrackingToken()
    .then(() => {
      if (attachments?.length) {
        return createAttachments(attachments);
      }

      return undefined;
    })
    .then((res) => {
      let attachmentIds;

      if (res) {
        attachmentIds = res.map((attachment) => attachment?.data?.id);
      }

      const payloadObj = {
        session: sessionId,
        body,
        payload,
        lastDeflection,
        attachments: attachmentIds,
        assistant: initAssistantPayload?.assistant,
        dialog: initAssistantPayload?.dialog,
        node: initAssistantPayload?.node,
        initialMessages: initAssistantPayload?.initialMessages,
      };
      const payloadRes = options?.assistantOptions?.emulation
        ? { ...payloadObj, assistantOptions: options?.assistantOptions }
        : payloadObj;

      if (isInAssistantMode) {
        return post(makePostChatAssistantMessageEndpoint(options), {
          body: JSON.stringify(payloadRes),
        });
      }

      return post(makePostChatMessageEndpoint(options), {
        body: JSON.stringify({
          session: sessionId,
          body,
          payload,
          lastDeflection,
          attachments: attachmentIds,
        }),
      });
    });
};

export const fetchMessageAttachments = (id: ChatMessagesData['id']) => {
  return get(makeGetChatMessageAttachmentsEndpoint(id));
};

export const fetchHistoricalMessages = (
  conversationId: string,
  options: FetchHistoricalMessagesOptions,
) => {
  return get(makeGetHistoricalMessagesEndpoint(conversationId, options));
};

export const delayFetchMessageAttachments = (id: ChatMessagesData['id']) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(fetchMessageAttachments(id));
    }, 400);
  }) as Promise<GetChatMessageAttachmentsApiResponse>;
};
